/* eslint-disable max-len */
/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { useMetaMask } from 'metamask-react';
import Web3 from 'web3/dist/web3.min';
import {
  ContractContainer,
  ContractElement,
  ContractHeader,
  ContractWrapper,
  ContractWalletText,
} from './contractElements';
import { CarbonButton } from '../../Utils/generalStyles';
import data from '../../constants/collections.json';
import { CheckNetwork } from '../../Utils/changeNetwork';
import Abis from '../../constants/abis.json';

// Functions
import MintForAddressSection from './Functions/mintForAddress';

const ContractSection = () => {
  const { connect, account, ethereum } = useMetaMask();
  const { CarbonCollectible } = data;
  const web3 = new Web3(ethereum);

  const {
    main: to, methods: {
      mintForAddress,
    },
  } = new web3.eth.Contract(Abis.main, CarbonCollectible.contract);

  return (
    <ContractContainer>
      <ContractWrapper>
        <ContractElement>
          <ContractHeader>Interact with contract</ContractHeader>
          {account ? (
            <>
              {window.ethereum.networkVersion !== CarbonCollectible.chainId ? (
                <CarbonButton
                  colored
                  onClick={() => CheckNetwork(CarbonCollectible.chainId)}
                >
                  Switch to Polygon
                </CarbonButton>
              ) : (
                <ContractWalletText>{`Connected wallet: ${account}`}</ContractWalletText>
              )}
            </>
          ) : (
            <CarbonButton colored onClick={connect}>Connect</CarbonButton>
          )}
        </ContractElement>
        {/* Functions here */}
        <MintForAddressSection onSumbit={(form) => {
          mintForAddress(form.amount, form.address).estimateGas({ from: account, to })
            .then((gasEstimate) => mintForAddress(form.amount, form.address).send({ from: account, to, gas: gasEstimate + 100000 })
              .then(() => {
                alert(`Minted ${form.amount} NFTs to given address`);
                // Make api call here
              })
              .catch(() => alert('Something went wrong. Check your input please.')))
            .catch(() => alert('Cant connect to contract. Try again later.'));
        }}
        />
      </ContractWrapper>
    </ContractContainer>
  );
};

export default ContractSection;
